export default (urls) =>
    urls.map((url) => {
        const image = new Image();
        image.src = url;
        return image;
    });
